const axios = require('axios');

const ANALYTIC_URL = 'https://cd-business-events-collector.content.cian.ru/events/';

require('@cnlabs/custom-elements-support-loader')(function () {
    const BANK_NAMES = {
        sovcombank: 'Совкомбанк',
        gazprombank: 'Газпромбанк',
        absolutbank: 'Абсолют Банк',
        rshb: 'РоссельхозБанк',
        unicredit: 'ЮникредитБанк',
    };

    function getBankName() {
        const {hostname} = window.location;
        if (hostname.includes('unicredit')) {
            return 'unicredit';
        }
        const array = hostname.split('.');
        return array.length === 2
            ? array[0]
            : array[1];
    }

    let mapLoading = false;

    function makeSuggest(part) {
        if (typeof ymaps !== 'undefined' && typeof ymaps.suggest !== 'undefined') {
            return ymaps.suggest(part);
        }
        if (mapLoading) {
            return null;
        }
        mapLoading = true;
        return new Promise(resolve => {
            const clbk = 'fn_' + new Date().getTime();
            window[clbk] = function () {
                const retry = () => {
                    ymaps.ready({require: 'suggest'}).then(() => {
                        mapLoading = false;
                        ymaps.suggest(part).then(resolve);
                    }).catch((e) => {
                        if (typeof ymaps.suggest !== 'undefined') {
                            ymaps.suggest(part).then(resolve);
                            mapLoading = false;
                        } else {
                            setTimeout(retry, 40);
                        }
                    });
                };
                retry();
            };
            const script = document.createElement('script');
            script.src = 'https://enterprise.api-maps.yandex.ru/2.1/?apikey=9614a954-a8c9-455f-bd7f-978887569cce&suggest_apikey=d2f48ca5-e882-4ec6-8961-b8ee523a42b1&lang=ru-RU&load=package.system,suggest&coordorder=longlat&onload=' + clbk;
            document.head.appendChild(script);
        });
    }

    const instance = axios.create({
        timeout: 3000,
    });

    async function analyticRequest(info) {
        const cianUserAbGroup = localStorage.getItem('cianUserAbGroup');
        const cianCdUser = localStorage.getItem('cianCdUser');
        const cianCdSession = sessionStorage.getItem('cianCdSession');
        const data = {
            cianCdUser,
            cianCdSession,
            cianUserAbGroup,
            objectType: info.objectType,
            rooms: info.rooms,
            priceFrom: info.priceFrom,
            priceTo: info.priceTo,
            region: info.region,
        };
        await instance.post(ANALYTIC_URL, {
            serviceName: info.serviceName,
            eventType: 'button-clicked',
            data,
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        })
    };

    if (!document.querySelector('script[src="//cdn.cian.site/finance/finance-input-with-slider/widget.js"]')) {
        const script = document.createElement('script');
        script.src = '//cdn.cian.site/finance/finance-input-with-slider/widget.js';
        document.head.appendChild(script);
    }
    if (!document.querySelector('script[src="//cdn.cian.site/cian-cd-checkbox/widget.js"]')) {
        const script = document.createElement('script');
        script.src = '//cdn.cian.site/finance/cian-cd-checkbox/widget.js';
        document.head.appendChild(script);
    }
    if (!document.querySelector('script[src="//cdn.cian.site/finance/content-distribution/customization.js"]')) {
        const script = document.createElement('script');
        script.src = '//cdn.cian.site/finance/content-distribution/customization.js';
        document.head.appendChild(script);
    }
    if (!document.querySelector('script[src="//cdn.cian.site/finance/more-filters/widget.js"]')) {
        const script = document.createElement('script');
        script.src = '//cdn.cian.site/finance/more-filters/widget.js';
        document.head.appendChild(script);
    }
    if (!customElements.get('content-distribution-filters-find-button')) customElements.define('content-distribution-filters-find-button', class extends HTMLElement {
        connectedCallback() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this));
            } else {
                this.init();
            }
        }

        init() {
            this.addEventListener('click', () => {
                this.dispatchEvent(new CustomEvent('CLOSE_OTHERS', {bubbles: true}));
                this.dispatchEvent(new CustomEvent('FIND_LIST_CLICKED', {bubbles: true}))
            })
        }
    });
    if (!customElements.get('content-distribution-filters-find-map-button')) customElements.define('content-distribution-filters-find-map-button', class extends HTMLElement {
        connectedCallback() {
            if (document.readyState !== 'complete') {
                console.log('readystate = ', document.readyState)
                window.addEventListener('load', this.init.bind(this));
            } else {
                this.init();
            }
        }

        init() {
            this.addEventListener('click', () => {
                this.dispatchEvent(new CustomEvent('CLOSE_OTHERS', {bubbles: true}));
                this.dispatchEvent(new CustomEvent('FIND_MAP_CLICKED', {bubbles: true}))
            })
        }
    });
    if (!customElements.get('content-distribution-filters')) customElements.define('content-distribution-filters', class extends HTMLElement {
        static get observedAttributes() {
            return ['cian-query', 'secondary-cian-query'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (this.currentQuery !== newValue && name !== 'secondary-cian-query') {
                this.restoreFilterState()
            }
        }

        connectedCallback() {
            /**
             * Данные для аналитики по фильтрам
             * @serviceName {string}  filters-search-analytics-offers |  filters-map-search-analytics-offers |  filters-search-analytics-jk |  filters-map-search-analytics-jk
             * @eventType {string} button-clicked
             * @data {
             *   @objectType {string}  all | new | used
             *   @rooms {array} 1 | 2 | 3 | 4 | 5 | 6 | studio - массив с выбранной комнатностью
             *   @priceFrom цена от
             *   @priceTo цена до
             *   @region - id региона
             *   @finishDate - id региона
             * }
             */
            this.analyticsData = {
                eventType: 'button-clicked',
                rooms: [],
            };
            if (document.readyState === 'loading') {
                console.log('loading')
                document.addEventListener('DOMContentLoaded', this.init.bind(this));
            } else {
                this.init();
            }
        }

        init() {
            if (!this.querySelector('content-distribution-filters-find-button')) {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', '//cdn.cian.site/finance/content-distribution-filters/desktop.html');
                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4) {
                        this.innerHTML = xhr.responseText;
                        if (this.hasAttribute('flip-buttons')) {
                            let m = this.querySelector('content-distribution-filters-find-map-button');
                            let f = this.querySelector('content-distribution-filters-find-button');
                            m.parentElement.removeChild(m);
                            f.parentElement.insertBefore(m, f);
                            f.querySelector('[text]').innerHTML = 'Списком'
                        }
                        setTimeout(() => this.init(), 100);
                    }
                };
                xhr.send();
                return;
            }

            let partnerProgramsString = localStorage.getItem('partner-programs');
            let partnerPrograms = !!partnerProgramsString ? JSON.parse(partnerProgramsString) : [];
            if (partnerPrograms.length > 0 ) {
                document.querySelector('.cian-filters-checkbox-container').style.display = 'block';
            } else {
                document.addEventListener('DISPATCH_PARTNER_PROGRAMS', () => {
                    try {
                        partnerProgramsString = localStorage.getItem('partner-programs');
                        partnerPrograms = !!partnerProgramsString ? JSON.parse(partnerProgramsString) : [];
                        if (partnerPrograms.length > 0 ) {
                            document.querySelector('.cian-filters-checkbox-container').style.display = 'block';
                        }
                    } catch (e) {
                        console.log('failed turn on checkbox', e)
                    }
                })
            }

            this.addEventListener('CLOSE_OTHERS', (e) => {
                this.querySelectorAll('[closable]').forEach((c) => {
                    e.target !== c && c.close && c.close();
                });
            });
            this.addEventListener('change', (e) => {
                if (e.target.tagName !== 'INPUT' && ((typeof e.value === "number") || (typeof e.value === "undefined"))) {
                    const attribute = 'price' + (e.target.hasAttribute('from') ? "_from" : "_to");
                    if (typeof e.value !== 'undefined')
                        this.setAttribute(attribute, e.value || null);
                    else
                        this.removeAttribute(attribute);
                    this.fireFilterChanged();
                }
            });
            this.addEventListener('room_changed', (e) => {
                this.fireFilterChanged();
            });
            this.addEventListener('category_changed', (e) => {
                this.fireFilterChanged();
            });
            this.addEventListener('region_changed', (e) => {
                this.fireFilterChanged();
            });
            document.addEventListener('SECONDARY_FILTERS_UPDATED', (e) => {
                this.setAttribute('secondary-cian-query', e.queryString)
                this.fireFilterChanged();
            });
            const handledEvents = new Set();
            this.addEventListener('FIND_LIST_CLICKED', async (e) => {
                if (!(handledEvents.has(e))) {
                    const regionElement = this.querySelector('content-distribution-filters-region-desktop');
                    if (regionElement && (regionElement.getAttribute('cian-query') || "").indexOf("newobject") >= 0) {
                        const [, newobject] = /newobject\[0]=([-0-9]+)/.exec(regionElement.getAttribute('cian-query')) || [];
                        if (newobject) {
                            fetch('https://partner-api.content.cian.ru/v2/get-newbuilding/?id=' + newobject).then(r => r.json()).then(r => {
                                const event = new CustomEvent('SHOW_JK', {bubbles: true});
                                event.jkRef = r.urlPath;
                                event.newTab = false;
                                this.dispatchEvent(event);
                            });
                        }
                    } else {
                        const event = new CustomEvent('FIND_LIST', {bubbles: true});
                        event.queryString = this.makeQueryString();

                        event.newTab = false;
                        document.dispatchEvent(event);
                        this.analyticsData.serviceName = 'filters-search-analytics-offers';
                        try {
                            await analyticRequest(this.analyticsData)
                        } catch (e) {
                            console.log(`Error from desktop-filters ${e}`)
                        }
                    }
                    e.stopPropagation();
                    handledEvents.add(e);
                    setTimeout(() => handledEvents.delete(e), 500);
                }
            });
            this.addEventListener('FIND_MAP_CLICKED', async (e) => {
                if (!(handledEvents.has(e))) {
                    const event = new CustomEvent('FIND_MAP', {bubbles: true});
                    event.queryString = this.makeQueryString();
                    event.newTab = false;
                    this.dispatchEvent(event);
                    e.stopPropagation();
                    handledEvents.add(e);
                    setTimeout(() => handledEvents.delete(e), 500);
                    this.analyticsData.serviceName = 'filters-map-search-analytics-offers';
                    try {
                        await analyticRequest(this.analyticsData)
                    } catch (e) {
                        console.log(`Error from desktop-filters ${e}`)
                    }
                }
            });

            document.addEventListener('click', () => {
                this.dispatchEvent(new CustomEvent('CLOSE_OTHERS', {bubbles: true}))
            });
            this.addEventListener('click', (e) => e.stopPropagation());
            this.restoreFilterState();
        }

        restoreFilterState() {
            this.currentQuery = this.getAttribute('cian-query')
                .replace('%5B', '[').replace('%5D', ']');
            if (document.readyState !== 'loading' && this.currentQuery) {
                const regionElement = this.querySelector('content-distribution-filters-region-desktop');
                if (regionElement)
                    regionElement.setAttribute("cian-query", this.currentQuery);
                const [, rType] = /object_type.0.=([^&]+)/.exec(this.currentQuery) || [];
                if (rType) {
                    const categoryElement = this.querySelector('content-distribution-filters-category');
                    if (categoryElement)
                        categoryElement.setAttribute("type", rType === "1" ? "resale" : "new");
                }

                const [, isPartnerPrograms] = /partner_programs=([^&]+)/.exec(this.currentQuery) || [];
                const partnersCheckbox = this.querySelector('#partner-programs-checkbox');
                if (!!partnersCheckbox) {
                    if (isPartnerPrograms && isPartnerPrograms === 'true') {
                        partnersCheckbox.setAttribute('selected', 'true');
                    } else partnersCheckbox.setAttribute('selected', 'false');
                }
                const [, minprice] = /minprice=([^&]+)/.exec(this.currentQuery) || [];
                const [, maxprice] = /maxprice=([^&]+)/.exec(this.currentQuery) || [];
                if (maxprice) {
                    this.setAttribute('price_to', maxprice);
                    if (window.cian_cd_compatibility_mode) {
                        this.querySelector('[to] input').value = maxprice;
                    } else {
                        if (this.querySelector('finance-input-with-slider[to]')) {
                            this.querySelector('finance-input-with-slider[to]').setAttribute('value', maxprice);
                            const input = this.querySelector('finance-input-with-slider[to]').firstChild;
                            if (input) {
                                input.value = Number(maxprice).toLocaleString('ru-RU');
                            }
                        }
                    }
                }
                if (minprice) {
                    this.setAttribute('price_from', minprice);
                    if (window.cian_cd_compatibility_mode) {
                        this.querySelector('[from] input').value = minprice;
                    } else {
                        if (this.querySelector('finance-input-with-slider[from]')) {
                            this.querySelector('finance-input-with-slider[from]').setAttribute('value', minprice);
                            const input = this.querySelector('finance-input-with-slider[from]');
                            if (input) {
                                input.value = Number(minprice).toLocaleString('ru-RU');
                            }
                        }
                    }
                }
                let selectedRooms = [];
                if (/room9=1/.test(this.currentQuery)) {
                    selectedRooms.push('s');
                }
                if (/room1=1/.test(this.currentQuery)) {
                    selectedRooms.push('1');
                }
                if (/room2=1/.test(this.currentQuery)) {
                    selectedRooms.push('2');
                }
                if (/room3=1/.test(this.currentQuery)) {
                    selectedRooms.push('3');
                }
                if (/room4=1/.test(this.currentQuery)) {
                    selectedRooms.push('4');
                }
                if (/room5=1/.test(this.currentQuery)) {
                    selectedRooms.push('5');
                }
                if (/room6=1/.test(this.currentQuery)) {
                    selectedRooms.push('6');
                }
                if (selectedRooms.length) {
                    const roomElement = this.querySelector('content-distribution-filters-rooms');
                    if (roomElement)
                        roomElement.setAttribute('selection', JSON.stringify(selectedRooms));
                }
            }
        }

        fireFilterChanged() {
            const event = new CustomEvent('FILTER_CHANGED', {bubbles: true});
            event.queryString = this.makeQueryString();
            const fullQs = this.makeQueryString() + this.getAttribute('secondary-cian-query')
            try {
                instance.post('https://gpb-service.content.cian.ru/offers-meta-by-query-string', {queryString: fullQs})
                    .then(({data}) => {
                        this.setSearchButtonsText(data?.count || '');
                    })
            } catch (e) {
                console.log(e)
                this.setSearchButtonsText('')
            }

            this.dispatchEvent(event);
        }

        setSearchButtonsText(count) {
            const lastTwoDigits = +count % 100;
            let title = `Показать ${count} объектов`;
            if (lastTwoDigits < 2) {
                title = `Показать ${count} объект`
            }
            if (lastTwoDigits > 1 && lastTwoDigits < 5) {
                title = `Показать ${count} объекта`
            }
            console.log(title);
            const secondaryFiltersSearchButton = this.querySelector('#cian-serp-secondary-filters-desktop-search-button')
            if (secondaryFiltersSearchButton) secondaryFiltersSearchButton.innerText = title;
        }


        makeQueryString() {
            let queryString = 'currency=2&deal_type=sale&engine_version=2&offer_type=flat';
            if (this.getAttribute('price_from')) {
                const priceFrom = this.getAttribute('price_from');
                this.analyticsData.priceFrom = priceFrom;
                queryString += '&minprice=' + priceFrom;
            }
            if (this.getAttribute('price_to')) {
                const priceTo = this.getAttribute('price_to');
                this.analyticsData.priceTo = priceTo;
                queryString += '&maxprice=' + priceTo;
            }
            const regionElement = this.querySelector('content-distribution-filters-region-desktop');
            if (regionElement && regionElement.hasAttribute('cian-query') || window.__regionId) {
                const region = regionElement.getAttribute('cian-query') || "region=" + window.__regionId;
                const regionArray = region.split('=');
                const regionId = regionArray[regionArray.length - 1];
                this.analyticsData.region = regionId;
                queryString += "&" + region;
            }
            const roomElement = this.querySelector('content-distribution-filters-rooms');
            if (roomElement && roomElement.getAttribute('selection')) {
                const rooms = JSON.parse(roomElement.getAttribute('selection'))
                    .map(v => {
                        const room = v === 's' ? '9' : v;
                        if (!this.analyticsData.rooms.includes(room)) {
                            this.analyticsData.rooms.push(room);
                        }
                        return room
                    })
                    .map(v => '&room' + v + "=1");
                queryString += rooms.join('');
            }
            const categoryElement = this.querySelector('content-distribution-filters-category');
            if (categoryElement && categoryElement.getAttribute('type')) {
                this.analyticsData.objectType = 'all';
                if (categoryElement.getAttribute('type') === 'new') {
                    queryString += '&object_type[0]=2';
                    this.analyticsData.objectType = 'new';
                }
                if (categoryElement.getAttribute('type') === 'resale') {
                    queryString += '&object_type[0]=1';
                    this.analyticsData.objectType = 'used';
                }
            }
            const partnersCheckbox = this.querySelector('#partner-programs-checkbox');
            if (partnersCheckbox && partnersCheckbox.getAttribute('selected')) {
                if (partnersCheckbox.getAttribute('selected') === 'true') {
                    queryString += '&partner_programs=true';
                } else queryString += '&partner_programs=false';
            }
            //todo uncomment if ok
            const secondaryQueryString = this.getAttribute('secondary-cian-query');
            if (secondaryQueryString) {
                queryString += secondaryQueryString;
            }
            return queryString;
        }
    });
    if (!customElements.get('content-distribution-filters-price')) customElements.define('content-distribution-filters-price', class extends HTMLElement {
        connectedCallback() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this));
            } else {
                this.init();
            }
        }

        init() {
            let htmlInputElement = this.querySelector('input');
            if (window.cian_cd_compatibility_mode) {
                const inputWithSlider = this.querySelector('finance-input-with-slider');
                inputWithSlider.removeChild(htmlInputElement);
                htmlInputElement.addEventListener('input', e => {
                    htmlInputElement.value = htmlInputElement.value.replace(/[^0-9]/g, "");
                    const customEvent = new CustomEvent("change", {bubbles: true});
                    customEvent.value = Number.parseInt(htmlInputElement.value);
                    this.dispatchEvent(customEvent)
                });
                this.replaceChild(htmlInputElement, inputWithSlider);
            }
            htmlInputElement.addEventListener('focus', (e) => {
                this.dispatchEvent(new CustomEvent('CLOSE_OTHERS', {bubbles: true}));
                const closest = e.target.closest('[catch-focus]');
                if (closest) closest.setAttribute('focus', 'true');
            });
            htmlInputElement.addEventListener('blur', (e) => {
                const closest = e.target.closest('[catch-focus]');
                if (closest) closest.setAttribute('focus', 'false');
            });
        }
    });
    if (!customElements.get('content-distribution-filters-category')) customElements.define('content-distribution-filters-category', class extends HTMLElement {
        connectedCallback() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.init.bind(this));
            } else {
                this.init();
            }
        }

        static get observedAttributes() {
            return ['type'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            const title = this.querySelector('[title]');
            const both = this.querySelector('[both]');
            const _new = this.querySelector('[new]');
            const old = this.querySelector('[old]');
            if (title && both && _new && old) {
                if (newValue) {
                    switch (newValue) {
                        case "new":
                            both.removeAttribute('selected');
                            _new.setAttribute('selected', 'true');
                            old.removeAttribute('selected');
                            title.innerHTML = 'Новостройка';
                            break;
                        case "resale":
                            both.removeAttribute('selected');
                            _new.removeAttribute('selected');
                            old.setAttribute('selected', 'true');
                            title.innerHTML = 'Вторичка';
                            break;
                    }
                } else {
                    both.setAttribute('selected', 'true');
                    _new.removeAttribute('selected');
                    old.removeAttribute('selected');
                    title.innerHTML = 'Новостройка и вторичка';

                }
            }
        }

        init() {

            const title = this.querySelector('[title]');
            const both = this.querySelector('[both]');
            const _new = this.querySelector('[new]');
            const old = this.querySelector('[old]');
            const popup = this.querySelector('[popup]');
            const svg = this.querySelector('svg');
            // For RBC hide category popup!
            if (window.location.hostname.includes('rbc')) {
                this.setAttribute('type', 'new');
                svg.style.display = 'none';
                popup.style.display = 'none';
                title.innerHTML = 'Новостройки';
                return;
            }
            popup.addEventListener('mouseleave', (e) => {
                this.close()
            });
            popup.addEventListener('click', (e) => {
                this.close();
                e.stopPropagation();
            });
            this.addEventListener('click', () => {
                this.dispatchEvent(new CustomEvent('CLOSE_OTHERS', {bubbles: true}));
                let popupVisible = popup.getAttribute('visible') !== "true";
                popup.setAttribute('visible', popupVisible);
                svg.setAttribute('state', popupVisible ? "open" : "close");
                this.setAttribute('state', popupVisible ? "open" : "close")
            });

            both.addEventListener('click', () => {
                both.setAttribute('selected', 'true');
                _new.removeAttribute('selected');
                old.removeAttribute('selected');
                title.innerHTML = 'Новостройка и вторичка';
                this.removeAttribute('type');
                this.dispatchEvent(new CustomEvent('category_changed', {bubbles: true}))
            });

            _new.addEventListener('click', () => {
                both.removeAttribute('selected');
                _new.setAttribute('selected', 'true');
                old.removeAttribute('selected', 'new');
                title.innerHTML = 'Новостройка';
                this.setAttribute('type', "new")
                this.dispatchEvent(new CustomEvent('category_changed', {bubbles: true}))
            });

            old.addEventListener('click', () => {
                both.removeAttribute('selected');
                _new.removeAttribute('selected');
                old.setAttribute('selected', 'true');
                title.innerHTML = 'Вторичка';
                this.setAttribute('type', "resale")
                this.dispatchEvent(new CustomEvent('category_changed', {bubbles: true}))
            });

        }

        close() {
            const popup = this.querySelector('[popup]');
            const svg = this.querySelector('svg');
            popup.setAttribute('visible', false);
            svg.setAttribute('state', "close");
            this.setAttribute('state', "close");
        }
    });
    if (!customElements.get('content-distribution-filters-region-desktop')) customElements.define('content-distribution-filters-region-desktop', class extends HTMLElement {
        connectedCallback() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.init());
            } else {
                this.init();
            }
        }

        static get observedAttributes() {
            return ['cian-query'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            // clean Up query
            if (newValue) {
                if (newValue.includes("in_polygon")) {
                    const [, pIdx, polygon_name] = /polygon_name\[([0-9])]=([^&]+)/.exec(newValue) || [];
                    const [, iIdx, in_polygon] = /in_polygon\[([0-9])]=([^&]+)/.exec(newValue) || [];
                    let count = 0;
                    for (let i = 0; i < newValue.length; i++) {
                        if (newValue[i] === '&') {
                            count++;
                            if (count > 1) {
                                this.setAttribute('cian-query', `polygon_name[${pIdx}]=${polygon_name}&in_polygon[${iIdx}]=${in_polygon}`);
                                return;
                            }
                        }
                    }
                    fetch('https://api.content.cian.ru/cian-api/site/v1/query-to-geo-tags/', {
                        method: "POST",
                        body: JSON.stringify({query_string: newValue + '&engine_version=2'})
                    }).then(v => v.json()).then(({data}) => {
                        if (data.geoTags && data.geoTags.polygon_tags[0]) {
                            this.querySelector('input').value = data.geoTags.polygon_tags[0].text;
                        }
                    });
                    return;
                }

                const [, builder] = /builder=([-0-9]+)/.exec(newValue) || [];
                if (builder) {
                    if (newValue.indexOf("&") >= 0) {
                        this.setAttribute('cian-query', 'builder=' + builder);
                        return;
                    }
                    fetch('https://api.content.cian.ru/cian-api/site/v1/query-to-geo-tags/', {
                        method: "POST",
                        body: JSON.stringify({query_string: newValue + '&engine_version=2'})
                    }).then(v => v.json()).then(({data}) => {
                        if (data.geoTags && data.geoTags.developer_tags[0]) {
                            this.querySelector('input').value = data.geoTags.developer_tags[0].text;
                        }
                    });
                    return;
                }
                const [, district] = /district\[0]=([-0-9]+)/.exec(newValue) || [];
                if (district) {
                    if (newValue.indexOf("&") >= 0) {
                        this.setAttribute('cian-query', 'district[0]=' + district);
                        return;
                    }
                    fetch('https://api.content.cian.ru/cian-api/site/v1/query-to-geo-tags/', {
                        method: "POST",
                        body: JSON.stringify({query_string: newValue + '&engine_version=2'})
                    }).then(v => v.json()).then(({data}) => {
                        if (data.geoTags && data.geoTags.district_tags[0]) {
                            this.querySelector('input').value = data.geoTags.district_tags[0].text;
                        }
                    });
                    return;
                }
                const [, metro] = /metro\[0]=([-0-9]+)/.exec(newValue) || [];
                if (metro) {
                    if (newValue.indexOf("&") >= 0) {
                        this.setAttribute('cian-query', 'metro[0]=' + metro);
                        return;
                    }
                    fetch('https://api.content.cian.ru/cian-api/site/v1/query-to-geo-tags/', {
                        method: "POST",
                        body: JSON.stringify({query_string: newValue + '&engine_version=2'})
                    }).then(v => v.json()).then(({data}) => {
                        if (data.geoTags && data.geoTags.metro_tags[0]) {
                            this.querySelector('input').value = data.geoTags.metro_tags[0].text;
                        }
                    });
                    return;
                }
                const [, newobject] = /newobject\[0]=([-0-9]+)/.exec(newValue) || [];
                if (newobject) {
                    if (newValue.indexOf("&") >= 0) {
                        this.setAttribute('cian-query', 'newobject[0]=' + newobject);
                        return;
                    }
                    fetch('https://api.content.cian.ru/cian-api/site/v1/query-to-geo-tags/', {
                        method: "POST",
                        body: JSON.stringify({query_string: newValue + '&engine_version=2'})
                    }).then(v => v.json()).then(({data}) => {
                        if (data.geoTags && data.geoTags.newobject_tags[0]) {
                            this.querySelector('input').value = data.geoTags.newobject_tags[0].text;
                        }
                    });
                    return;
                }
                const [, railway] = /railway\[0]=([-0-9]+)/.exec(newValue) || [];
                if (railway) {
                    if (newValue.indexOf("&") >= 0) {
                        this.setAttribute('cian-query', 'railway[0]=' + railway);
                        return;
                    }
                    fetch('https://api.content.cian.ru/cian-api/site/v1/query-to-geo-tags/', {
                        method: "POST",
                        body: JSON.stringify({query_string: newValue + '&engine_version=2'})
                    }).then(v => v.json()).then(({data}) => {
                        if (data.geoTags && data.geoTags.railway_tags[0]) {
                            this.querySelector('input').value = data.geoTags.railway_tags[0].text;
                        }
                    });
                    return;
                }
                const [, house] = /house\[0]=([-0-9]+)/.exec(newValue) || [];
                if (house) {
                    if (newValue.indexOf("&") >= 0) {
                        this.setAttribute('cian-query', 'house[0]=' + house);
                        return;
                    }
                    fetch('https://api.content.cian.ru/cian-api/site/v1/query-to-geo-tags/', {
                        method: "POST",
                        body: JSON.stringify({query_string: newValue + '&engine_version=2'})
                    }).then(v => v.json()).then(({data}) => {
                        if (data.geoTags && data.geoTags.address_tags[0]) {
                            this.querySelector('input').value = data.geoTags.address_tags[0].text;
                        }
                    });
                    return;
                }
                const [, street] = /street\[0]=([-0-9]+)/.exec(newValue) || [];
                if (street) {
                    if (newValue.indexOf("&") >= 0) {
                        this.setAttribute('cian-query', 'street[0]=' + street);
                        return;
                    }
                    fetch('https://api.content.cian.ru/cian-api/site/v1/query-to-geo-tags/', {
                        method: "POST",
                        body: JSON.stringify({query_string: newValue + '&engine_version=2'})
                    }).then(v => v.json()).then(({data}) => {
                        if (data.geoTags && data.geoTags.address_tags[0]) {
                            this.querySelector('input').value = data.geoTags.address_tags[0].text;
                        }
                    });
                    return;
                }
                const [, region] = /region=([-0-9]+)/.exec(newValue) || [];
                if (region) {
                    if (newValue.indexOf("&") >= 0) {
                        this.setAttribute('cian-query', 'region=' + region);
                        return;
                    }
                    fetch('https://api.content.cian.ru/get-locations/?id=' + region)
                        .then(v => v.json()).then(({name}) => {
                        if (name) {
                            this.querySelector('input').value = name;
                        }
                    });
                    return;
                }
                this.removeAttribute('cian-query');
            }
        }
        isOpenBank() {
            const { hostname, search } = location;
            return hostname.includes('open') || search.includes('test');
        }
        init() {
            const inputElement = this.querySelector('input');
            const popup = this.querySelector('[popup]');
            const svg = this.querySelector('svg');

            const makeRequest = (query) => {
                const highlightQuery = (text) => {
                    const idx = text.toLowerCase().indexOf(query.toLowerCase());
                    if (idx < 0) {
                        return text;
                    }
                    if (idx === 0) {
                        return `<b>${text.substring(0, query.length)}</b>${text.substring(query.length)}`;
                    }
                    if (idx === text.length - query.length) {
                        return `${text.substring(0, idx)}<b>${text.substring(idx)}</b>`;
                    }
                    return `${text.substring(0, idx)}<b>${text.substring(idx, idx + query.length)}</b>${text.substring(idx + query.length)}`;

                };
                let cianQuery = this.getAttribute('cian-query');
                if (this.isOpenBank()) {
                    const filterQuery = document.querySelector('jk-filters').getAttribute('cian-query');
                    if (filterQuery && filterQuery.includes('region')) {
                        const [, region] = /region=([-0-9]+)/.exec(filterQuery) || [];
                        if (cianQuery) {
                            cianQuery += `&region=${region}`
                        }
                        cianQuery = `region=${region}`
                    }
                }
                Promise.all(
                    [
                        makeSuggest(query),
                        fetch('https://content-distribution-newbuilding.content.cian.ru/geo-suggest?query=' + encodeURIComponent(query) + "&" + cianQuery)
                    ]
                ).then(([ya, cian]) => {
                    if (ya) {
                        const yandexArray = ya.filter((el) => !el.displayName.includes('жилой комплекс'));
                        popup.querySelector('[addressesList]').innerHTML = yandexArray.map(v => {
                                return `<div text="${v.displayName}" yandex-value="${v.value}" style="cursor: pointer; padding: 10px 5px 10px 24px">&nbsp;${highlightQuery(v.displayName)}</div>`
                            }
                        ).join('\n');
                    }
                    cian.json().then(async parse => {
                        const BankNameFromHost = getBankName();
                        const bankName = BANK_NAMES[BankNameFromHost];
                        parse.cities = parse.cities || {items: []};
                        parse.districts = parse.districts || {items: []};
                        parse.newbuildings = parse.newbuildings || {items: []};
                        parse.railways = parse.railways || {items: []};
                        parse.roads = parse.roads || {items: []};
                        parse.undergrounds = parse.undergrounds || {items: []};
                        parse.builders = parse.builders || {items: []};
                        const {cities: {items: cities}, districts: {items: districts}, newbuildings: {items: newbuildings}, railways: {items: railways}, undergrounds: {items: undergrounds}, builders: {items: builders}} = parse;

                        if (newbuildings.length) {
                            const jkRef = newbuildings.map((newbuilding) => newbuilding.link);
                            const req = await fetch('https://gpb-service.content.cian.ru/api/v2/get-nebuildings-by-bank',
                                {
                                    method: 'POST',
                                    headers: {'Content-Type': 'application/json'},
                                    body: JSON.stringify({
                                        links: jkRef,
                                        bankName,
                                    })
                                });

                            let newbuildingData = [];
                            if (req.ok) {
                                newbuildingData = await req.json();
                            }
                            ;

                            if (newbuildingData.length) {
                                popup.querySelector('[jkList]').innerHTML = newbuildingData.map(v => {
                                        return `
                                            <div text="${v.name}" query-criteria="newobject[0]=${v.id}" style="cursor: pointer; margin-bottom: 10px">
                                                <div class="cian-filters-desktop-jk-card-mini__container">
                                                    <div class="cian-filters-desktop-jk-card-mini__item">
                                                        <div class="cian-filters-desktop-jk-card-mini__name">${v.displayName}</div>
                                                        <div class="cian-filters-desktop-jk-card-mini__status">${v.specialStatusDisplay}</div>
                                                        <div class="cian-filters-desktop-jk-card-mini__price">${v.priceForObjectFromDeveloperDisplay}</div>
                                                    </div>
                                                    <div class="cian-filters-desktop-jk-card-mini__img">
                                                        <img src="${v.photo.thumbnailUrl}" alt="${v.photo.alt}">
                                                    </div>
                                                </div>
                                            </div>
                                            <style>
                                                .cian-filters-desktop-jk-card-mini__container {
                                                      display: flex;
                                                      justify-content: space-between;
                                                      background-color: var(--ice, #F8F8F8);
                                                      padding: 10px 5px 10px 24px;
                                                }
                                                .cian-filters-desktop-jk-card-mini__item {
                                                  display: flex;
                                                  flex-direction: column;
                                                }
                                                
                                                .cian-filters-desktop-jk-card-mini__img {
                                                  max-width: 30%;
                                                  max-height: 80px;
                                                }
                                                
                                                .cian-filters-desktop-jk-card-mini__img img {
                                                  height: 100%;
                                                  width: 100%;
                                                }
                                                
                                                .cian-filters-desktop-jk-card-mini__name {
                                                  font-weight: bold;
                                                  margin-bottom: 5px;
                                                }
                                                
                                                .cian-filters-desktop-jk-card-mini__status {
                                                  text-transform: lowercase;
                                                  font-size: 14px;
                                                  color: var(--asphalt, #807D7D);
                                                  margin-bottom: 10px;
                                                }
                                                div[metrolist] {
                                                  padding-left: 24px;
                                                }
                                                .hide {
                                                  display: none !important;
                                                }
                                            </style>
                                      `
                                    }
                                ).join('\n');
                            }
                        }
                        popup.querySelector('[districtsList]').innerHTML = districts.map(v => {
                                return `<div text="${v.name}" query-criteria="district[0]=${v.id}" style="cursor: pointer; padding: 10px 5px 10px 24px">&nbsp;${highlightQuery(v.name)}</div>`
                            }
                        ).join('\n');
                        popup.querySelector('[metroList]').innerHTML = undergrounds.map(v => {
                                if (!v.lines.length) {
                                    return `<div text="${v.name}" query-criteria="metro[0]=${v.id}" style="cursor: pointer; padding: 10px 5px 10px 24px">&nbsp;${highlightQuery(v.name)}</div>`
                                } else {
                                    let svg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">`;
                                    for (let i = v.lines.length - 1; i >= 0; i--) {
                                        svg += `<path  transform='translate(${3 * i} 0)' d="M7.5 12C7.5 14.4855 9.51452 16.5 12 16.5C14.4855 16.5 16.5 14.4855 16.5 12C16.5 9.51452 14.4855 7.5 12 7.5C9.51452 7.5 7.5 9.51452 7.5 12Z" fill="#${v.lines[i].lineColor}" stroke="white"/>`;
                                    }
                                    svg += `</svg>`;
                                    return `<div query-criteria style="display: flex; align-items: center">${svg}<div text="${v.name}" query-criteria="metro[0]=${v.id}" style="cursor: pointer; padding: 10px 5px 10px 0">&nbsp;${highlightQuery(v.name)}</div></div>`
                                }
                            }
                        ).join('\n');
                        popup.querySelector('[citiesList]').innerHTML = cities.map(v => {
                                return `<div text="${v.name}" query-criteria="region=${v.id}" style="cursor: pointer; padding: 10px 5px 10px 24px">&nbsp;${highlightQuery(v.name)}</div>`
                            }
                        ).join('\n');
                        //todo start
                        popup.querySelector('[buildersList]').innerHTML = builders.map(v => {

                                    return `<div text="${v.name}" query-criteria="builder=${v.id}" style="cursor: pointer; padding: 10px 5px 10px 24px">&nbsp;${highlightQuery(v.name)}</div>`

                            }
                        ).join('\n');
                        //todo finish
                        popup.querySelector('[jdList]').innerHTML = railways.map(v => {
                                return `<div text="${v.name}" query-criteria="railway[0]=${v.id}" style="cursor: pointer; padding: 10px 5px 10px 24px">&nbsp;${highlightQuery(v.name)}</div>`
                            }
                        ).join('\n');

                        if (!districts.length) popup.querySelector('[districtsBlock]').classList.add('hide'); else popup.querySelector('[districtsBlock]').classList.remove('hide');
                        if (!undergrounds.length) popup.querySelector('[metroBlock]').classList.add('hide'); else popup.querySelector('[metroBlock]').classList.remove('hide');
                        if (!cities.length) popup.querySelector('[citiesBlock]').classList.add('hide'); else popup.querySelector('[citiesBlock]').classList.remove('hide');
                        if (!builders.length) popup.querySelector('[buildersList]').classList.add('hide'); else popup.querySelector('[buildersList]').classList.remove('hide');
                        // if (document.querySelector('[buildersList]').innerText === '') popup.querySelector('[buildersBlock]').classList.add('hide'); else popup.querySelector('[buildersBlock]').classList.remove('hide');
                        if (!railways.length) popup.querySelector('[jdBlock]').classList.add('hide'); else popup.querySelector('[jdBlock]').classList.remove('hide');

                        this.dispatchEvent(new CustomEvent('CLOSE_OTHERS', {bubbles: true}));
                        popup.setAttribute('visible', "true");
                        svg.setAttribute('state', "open");
                        this.setAttribute('state', "open");
                    });
                });
            };
            inputElement.addEventListener('input', (e) => {
                makeRequest(inputElement.value);
            });
            inputElement.addEventListener('focus', (e) => {
                this.dispatchEvent(new CustomEvent('CLOSE_OTHERS', {bubbles: true}));
                const closest = e.target.closest('[catch-focus]');
                if (closest) closest.setAttribute('focus', 'true');
            });
            inputElement.addEventListener('blur', (e) => {
                const closest = e.target.closest('[catch-focus]');
                if (closest) closest.setAttribute('focus', 'false');
            });


            this.addEventListener('click', (e) => {
                if (e.target.closest('[clear]')) {
                    this.querySelector('input').value = "";
                    this.removeAttribute('cian-query');
                    this.dispatchEvent(new CustomEvent('region_changed', {bubbles: true}));
                    this.close();
                }
            });


            popup.addEventListener('click', (e) => {
                const closest = e.target.closest("[query-criteria]");
                const queryCriteria = closest && closest.getAttribute('query-criteria');

                if (queryCriteria) {
                    inputElement.value = closest.getAttribute('text');
                    this.setAttribute('cian-query', queryCriteria);
                    this.dispatchEvent(new CustomEvent('region_changed', {bubbles: true}));
                    this.close()
                }
                const yaValueClosest = e.target.closest("[yandex-value]");
                const yandexValue = yaValueClosest && yaValueClosest.getAttribute('yandex-value');
                if (yandexValue) {
                    inputElement.value = yaValueClosest.getAttribute('text');
                    fetch('https://www.cian.ru/api/geo/geocode-cached?request=' + encodeURIComponent(yandexValue)).then(r => r.json()).then(({items}) => {
                        let formData = "";
                        formData += 'Lng=' + items[0].coordinates[0] + "&";
                        formData += 'Lat=' + items[0].coordinates[1] + "&";
                        formData += 'Kind=' + items[0].kind + "&";
                        formData += 'Address=' + encodeURIComponent(items[0].text);
                        fetch('https://www.cian.ru/api/geo/geocoded-for-search', {
                            method: 'POST',
                            body: formData,
                            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                        })
                            .then(r => r.json())
                            .then(data => {
                                for (let i = data.details.length - 1; i >= 0; i--) {
                                    const resolved = data.details[i];
                                    if (resolved.id === 0) {
                                        let query = 'polygon_name[1]=' + encodeURIComponent(items[0].name) + "&" +
                                            'in_polygon[1]=' + encodeURIComponent([
                                                `${items[0].boundedBy[0][0]}_${items[0].boundedBy[0][1]}`,
                                                `${items[0].boundedBy[0][0]}_${items[0].boundedBy[1][1]}`,
                                                `${items[0].boundedBy[1][0]}_${items[0].boundedBy[1][1]}`,
                                                `${items[0].boundedBy[1][0]}_${items[0].boundedBy[0][1]}`,
                                                `${items[0].boundedBy[0][0]}_${items[0].boundedBy[0][1]}`,
                                            ].join(","));
                                        this.setAttribute('cian-query', query);
                                        this.dispatchEvent(new CustomEvent('region_changed', {bubbles: true}));
                                        this.close();
                                        return;
                                    }

                                    switch (resolved.geoType.toLowerCase()) {
                                        case 'location':
                                            inputElement.value = resolved.fullName;
                                            this.setAttribute('cian-query', 'region=' + resolved.id);
                                            this.dispatchEvent(new CustomEvent('region_changed', {bubbles: true}));
                                            this.close();
                                            return;
                                        case 'house':
                                            inputElement.value = resolved.fullName;
                                            this.setAttribute('cian-query', 'house[0]=' + resolved.id);
                                            this.dispatchEvent(new CustomEvent('region_changed', {bubbles: true}));
                                            this.close();
                                            return;
                                        case 'railway':
                                            inputElement.value = resolved.fullName;
                                            this.setAttribute('cian-query', 'railway[0]=' + resolved.id);
                                            this.dispatchEvent(new CustomEvent('region_changed', {bubbles: true}));
                                            this.close();
                                            return;
                                        case 'district':
                                            inputElement.value = resolved.fullName;
                                            this.setAttribute('cian-query', 'district[0]=' + resolved.id);
                                            this.dispatchEvent(new CustomEvent('region_changed', {bubbles: true}));
                                            this.close();
                                            return;
                                        case 'underground':
                                            inputElement.value = resolved.fullName;
                                            this.setAttribute('cian-query', 'metro[0]=' + resolved.id);
                                            this.dispatchEvent(new CustomEvent('region_changed', {bubbles: true}));
                                            this.close();
                                            return;
                                        case 'street':
                                            inputElement.value = resolved.fullName;
                                            this.setAttribute('cian-query', 'street[0]=' + resolved.id);
                                            this.dispatchEvent(new CustomEvent('region_changed', {bubbles: true}));
                                            this.close();
                                            return;
                                    }
                                }
                            });
                    });
                }

                e.stopPropagation();
            });
        }

        close() {
            const popup = this.querySelector('[popup]');
            const svg = this.querySelector('svg');
            popup.setAttribute('visible', false);
            svg.setAttribute('state', "close");
            this.setAttribute('state', "close");
        }
    });


    function makeIntervals(selectionArray) {
        let intervals = selectionArray.join(",");
        intervals = intervals.replace("1,2,3,4,5,6", "1-6");
        intervals = intervals.replace("1,2,3,4,5", "1-5");
        intervals = intervals.replace("2,3,4,5,6", "2-6");
        intervals = intervals.replace("1,2,3,4", "1-4");
        intervals = intervals.replace("2,3,4,5", "2-5");
        intervals = intervals.replace("3,4,5,6", "3-6");
        intervals = intervals.replace("1,2,3", "1-3");
        intervals = intervals.replace("2,3,4", "2-4");
        intervals = intervals.replace("3,4,5", "3-5");
        intervals = intervals.replace("4,5,6", "4-6");
        return intervals;
    }

    if (!customElements.get('content-distribution-filters-rooms')) customElements.define('content-distribution-filters-rooms', class extends HTMLElement {
        static get observedAttributes() {
            return ['selection'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            const title = this.querySelector('[title]');
            const selection = new Set(JSON.parse(this.getAttribute('selection') || '[]'));
            if (selection.size === 0) {
                title.innerHTML = 'Комнат';
                return;
            }
            if (selection.size === 1 && selection.has('s')) {
                title.innerHTML = 'Студия';
                return;
            }
            const wasStudio = selection.delete('s');
            const selectionArray = Array.from(selection).sort();
            title.innerHTML = makeIntervals(selectionArray) + " к.к";
            if (wasStudio) {
                title.innerHTML += "; Студ."
            }
            this.dispatchEvent(new CustomEvent('room_changed', {bubbles: true}))
            const upd = (sel, m, arr) => {

                const q = this.querySelector(sel);
                if (q) {
                    if (arr.indexOf(m) >= 0) {
                        q.setAttribute('selected', "");
                    } else {
                        q.removeAttribute('selected')
                    }
                }
            };
            const q = this.querySelector('[studio]');
            if (q) {
                if (wasStudio) {
                    q.setAttribute('selected', "");
                } else {
                    q.removeAttribute('selected')
                }
            }
            upd('[k1]', '1', selectionArray);
            upd('[k2]', '2', selectionArray);
            upd('[k3]', '3', selectionArray);
            upd('[k4]', '4', selectionArray);
            upd('[k5]', '5', selectionArray);
            upd('[k6]', '6', selectionArray);
        }

        connectedCallback() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.init());
            } else {
                this.init();
            }
        }

        addSelection(v) {
            const selection = new Set(JSON.parse(this.getAttribute('selection') || '[]'));
            selection.add(v);
            this.setAttribute('selection', JSON.stringify(Array.from(selection).sort()));
        }

        removeSelection(v) {
            const selection = new Set(JSON.parse(this.getAttribute('selection') || '[]'));
            selection.delete(v);
            this.setAttribute('selection', JSON.stringify(Array.from(selection).sort()));
        }

        init() {
            const studio = this.querySelector('[studio]');
            const k1 = this.querySelector('[k1]');
            const k2 = this.querySelector('[k2]');
            const k3 = this.querySelector('[k3]');
            const k4 = this.querySelector('[k4]');
            const k5 = this.querySelector('[k5]');
            const k6 = this.querySelector('[k6]');
            studio.addEventListener('click', () => {
                const selection = JSON.parse(this.getAttribute('selection') || '[]');
                if (studio.hasAttribute("selected")) {
                    studio.removeAttribute('selected');
                    this.removeSelection('s');
                } else {
                    studio.setAttribute('selected', 'true');
                    this.addSelection('s');
                }
            });
            k1.addEventListener('click', () => {
                const selection = JSON.parse(this.getAttribute('selection') || '[]');
                if (k1.hasAttribute("selected")) {
                    k1.removeAttribute('selected');
                    this.removeSelection('1');
                } else {
                    k1.setAttribute('selected', 'true');
                    this.addSelection('1');
                }
            });
            k2.addEventListener('click', () => {
                const selection = JSON.parse(this.getAttribute('selection') || '[]');
                if (k2.hasAttribute("selected")) {
                    k2.removeAttribute('selected');
                    this.removeSelection('2');
                } else {
                    k2.setAttribute('selected', 'true');
                    this.addSelection('2');
                }
            });
            k3.addEventListener('click', () => {
                const selection = JSON.parse(this.getAttribute('selection') || '[]');
                if (k3.hasAttribute("selected")) {
                    k3.removeAttribute('selected');
                    this.removeSelection('3');
                } else {
                    k3.setAttribute('selected', 'true');
                    this.addSelection('3');
                }
            });
            k4.addEventListener('click', () => {
                const selection = JSON.parse(this.getAttribute('selection') || '[]');
                if (k4.hasAttribute("selected")) {
                    k4.removeAttribute('selected');
                    this.removeSelection('4');
                } else {
                    k4.setAttribute('selected', 'true');
                    this.addSelection('4');
                }
            });
            k5.addEventListener('click', () => {
                const selection = JSON.parse(this.getAttribute('selection') || '[]');
                if (k5.hasAttribute("selected")) {
                    k5.removeAttribute('selected');
                    this.removeSelection('5');
                } else {
                    k5.setAttribute('selected', 'true');
                    this.addSelection('5');
                }
            });
            k6.addEventListener('click', () => {
                const selection = JSON.parse(this.getAttribute('selection') || '[]');
                if (k6.hasAttribute("selected")) {
                    k6.removeAttribute('selected');
                    this.removeSelection('6');
                } else {
                    k6.setAttribute('selected', 'true');
                    this.addSelection('6');
                }
            });

            const popup = this.querySelector('[popup]');

            const svg = this.querySelector('svg');

            popup.addEventListener('mouseleave', (e) => {
                this.close()
            });
            popup.addEventListener('click', (e) => e.stopPropagation());
            this.addEventListener('click', () => {
                this.dispatchEvent(new CustomEvent('CLOSE_OTHERS', {bubbles: true}));
                let popupVisible = popup.getAttribute('visible') !== "true";
                popup.setAttribute('visible', popupVisible);
                svg.setAttribute('state', popupVisible ? "open" : "close");
                this.setAttribute('state', popupVisible ? "open" : "close");
            });
            this.attributeChangedCallback('selection', null, this.getAttribute('selection'));
        }

        close() {
            const popup = this.querySelector('[popup]');
            const svg = this.querySelector('svg');
            popup.setAttribute('visible', false);
            svg.setAttribute('state', "close");
            this.setAttribute('state', "close");
        }
    });
});
